import IssueFormFieldTypes from '@/features/issueFormMetadata/IssueFormFieldTypes.vue';
import { IssueFormMetadataRels } from '@/features/issueFormMetadata/rels';

export const IssueFormMetadataRoutes = [
    {
        path: '/issue-form-field-types',
        name: IssueFormMetadataRels.GetIssueFormFieldTypes,
        component: IssueFormFieldTypes
    }
];
